/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-get, warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';

import PersonType from '@linc-technologies/linced-common/enums/person-type';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import moment from 'moment';
import { service } from '@ember/service';

export default class ChangeOfAttendanceRecordRoute extends Route {
  queryParams = {
    dateFrom: {
      refreshModel: true,
    },
    dateTo: {
      refreshModel: true,
    },
  };

  // Services
  @service
  session;

  @service
  store;

  // State
  dateFrom = moment().format('YYYY-01-01');

  dateTo = moment().format('YYYY-12-31');

  // Methods
  model(params) {
    let dateFrom = params.dateFrom || this.dateFrom;
    let dateTo = params.dateTo || this.dateTo;
    let year = moment(dateFrom).year();
    let schoolId = this.get('session.activeSchool');

    return hash({
      audits: this.store.query('attendance/audit', {
        schoolId,
        dateFrom,
        dateTo,
      }),
      dates: this.store.query('date', { schoolId, year }),
      people: this.store.query('person', {
        type: PersonType.LEARNER,
        includeFormer: true,
      }),
      records: this.store.query('attendance/record', {
        schoolId,
        dateFrom,
        dateTo,
      }),
      // Resolved to a plain array: the {{reverse}} template helper calls
      // A() on it, which throws on ember-data's live-array proxy.
      terms: this.store.findAll('term').then((terms) => terms.slice()),
    });
  }

  resetController(controller) {
    controller.reset();
  }
}
